"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFakeUploadMedia = void 0;
var react_1 = require("react");
var useFakeUploadMedia = function (options) {
    if (options === void 0) { options = {}; }
    var handleUploadProgess = options.handleUploadProgess;
    var _a = (0, react_1.useState)(false), isLoading = _a[0], setIsLoading = _a[1];
    var mutate = function (files, callbacks) {
        if (callbacks === void 0) { callbacks = {}; }
        var onSuccess = callbacks.onSuccess;
        setIsLoading(true);
        // FileReader support
        if (FileReader && files && files.length) {
            var fileReader = new FileReader();
            fileReader.addEventListener("progress", function (ev) {
                handleUploadProgess &&
                    handleUploadProgess(Math.round((100 * ev.loaded) / ev.total));
            });
            recursFileReader({
                fileReader: fileReader,
                files: files,
                index: 0,
                onComplete: function (finalData) {
                    setIsLoading(false);
                    onSuccess(finalData);
                },
            });
        }
        // Not supported
        else {
            setIsLoading(false);
            onSuccess([]);
        }
    };
    return { mutate: mutate, isLoading: isLoading };
};
exports.useFakeUploadMedia = useFakeUploadMedia;
var recursFileReader = function (_a) {
    var fileReader = _a.fileReader, files = _a.files, index = _a.index, _b = _a.finalData, finalData = _b === void 0 ? [] : _b, onComplete = _a.onComplete;
    if (index >= files.length) {
        onComplete(finalData);
        return;
    }
    var file = files[index];
    fileReader.onload = function () {
        finalData.push({
            fileData: { publicUrl: fileReader.result },
            status: "success",
        });
        recursFileReader({
            fileReader: fileReader,
            files: files,
            index: index + 1,
            finalData: finalData,
            onComplete: onComplete,
        });
    };
    fileReader.readAsDataURL(file);
};
